import type { ReactNode } from 'react';

import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';
import { operatorItems } from 'components/powerFlowShared/components/modals/filters/util/helper';

import { getVariableName } from './utils/variable/getVariableName';

type FilterNode = ConversationFlowAuditLogEntry<
  | 'EMAIL_EXTERNAL_DATA_ROUTING_NODE_VISITED'
  | 'TELEPHONY_EXTERNAL_DATA_ROUTING_NODE_VISITED'
  | 'MESSENGER_EXTERNAL_DATA_ROUTING_NODE_VISITED'
>;

type RoutedThroughFilterProps = {
  node: FilterNode;
};

function getMatchText(node: FilterNode): ReactNode {
  if (node.is_matching === false) {
    return 'No match';
  }

  const operator = Object.values(operatorItems).find(
    ({ id }) => id.toUpperCase() === node.matching_rule?.toUpperCase(),
  );

  return (
    <>
      {getVariableName(node.variable_id)} {operator?.name}{' '}
      <strong>{node.value}</strong>
    </>
  );
}

export function RoutedThroughFilter({
  node,
}: RoutedThroughFilterProps): JSX.Element {
  return (
    <>
      Filter <strong>{node.description}</strong> · {getMatchText(node)}
    </>
  );
}
